<template>
<section class="styled-table p-4">
    <SmoothLoader class="table-container overflow-x-scroll max-w-4xl mx-auto rounded-md">
        <table class="w-full">
            <thead class="bg-primary-600 text-white font-headline" v-if="headers.length">
                <th class="p-4 text-left" v-for="header in headers" v-html="header"></th>
            </thead>
            <tbody>
                <tr v-for="(row, i) in rows" :class="{'bg-white': i % 2, 'bg-gray-400': !(i % 2)}">
                    <td class="px-4 py-2 text-primary-600" v-for="cell in row" v-html="cell"></td>
                </tr>
            </tbody>
        </table>
    </SmoothLoader>
</section>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
export default {
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    }
}
</script>